/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import {
  FormControl,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  InputLabel,
  Tab,
  Tabs,
} from '@mui/material';
import {
  MarketsSelect
} from 'components';
import {
  StoreUtil,
} from 'doctivity-shared/utils';
import {
  MarketsUtil,
} from 'utils';
import {
  TagSelector
} from 'tags/TagSelector';
import { setMarket } from 'store/actions/appActions';
import { listTagNamespacesByClient } from 'store/actions/tagNamespacesActions';
import { TagsUtil } from '../utils';

const styles = (theme) => ({
  dialogTitle: {
    paddingBottom: 0,
  },
  dialogContent: {
    height: 300,
    paddingTop: 30,
  },
  filterDropDown: {
    width: 168,
    marginRight: theme.spacing(),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  lockIcon: {
    fontSize: 'inherit',
    verticalAlign: 'text-top',
    marginRight: 2,
    paddingRight: 6,
    color: '#999999',
  },
  tabs: {
    paddingBottom: 0,
  },
  parentServiceline: {
    borderTop: '1px solid #cccccc',
  },
  subServiceline: {
    fontSize: 14,
    paddingLeft: theme.spacing(4),
  },
  tagFilteringOrganization: {
    fontSize: 14,
    fontWeight: 200,
  }
});

class MarketOrTagSelect extends React.Component {
  constructor(props) {
    super(props);
    let selectedFilter = props.filter ? props.filter : undefined;
    if (!selectedFilter) {
      console.log('NO SELECTED FILTER');
      selectedFilter = { type: 'market', market: {}, tag: {}};
    }
    this.state = {
      marketsEditOpen: false,
      tab: selectedFilter.type === 'market' ? 'markets' : 'tags',
      open: false,
      selectedFilter,
      previousFilter: selectedFilter,
    };
  }

  componentDidMount() {
    this.checkTagsState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.open && this.state.open ) {
      if (this.props.allowTagSelection !== undefined && !this.props.allowTagSelection && this.state.selectedFilter?.type === 'tag' )  {
      this.setState({ selectedFilter: undefined, tab: 'markets'});
      } else {
        this.setState({ 
          tab: this.state.selectedFilter?.type === 'tag' ? 'tags' : 'markets',
        });
      }
    }
    if (prevProps.filter !== this.props.filter) {
      this.setState({
        selectedFilter: this.props.filter,
        previousFilter: this.props.filter,
      });
    }
    this.checkTagsState();
  }

  checkTagsState() {
    if (StoreUtil.needsLoadLongCache(this.props.tagNamespaces) || this.props.tagNamespaces.clientId !== this.props.clientId) {
      return this.fetchTags();
    }

    const previousFilter = this.state.previousFilter;
    if (StoreUtil.isLoaded(this.props.tagNamespaces) && previousFilter?.tag && previousFilter.tag.id && !previousFilter.tag.name) {
      const tag = TagsUtil.findTag(previousFilter.tag.id, this.props.tagNamespaces);
      if (tag) {
        this.setState((state) => ({
          previousFilter: {
            ...state.previousFilter,
            tag,
          }
        }));
      } else {
        // this usually means there was a switch of clients and the tag is not accessible from this client
        console.log('tag not found: ', previousFilter.tag.id);
        // lets default to first tag in first namespace
        const tag = TagsUtil.getNamespacesByType(this.props.type ?? 'providers', this.props.tagNamespaces)?.find((ns) => ns.tags.length > 0)?.tags[0];
        if (tag) {
          if (previousFilter.type === 'tag') {
            this.props.onChange?.({ ...previousFilter, tag });
          } else {
            this.setState({
              previousFilter: {
                ...previousFilter,
                tag,
              },
            });
          }
        }
      }
    }
  }

  fetchTags() {
    this.props.dispatch(
      listTagNamespacesByClient(
        this.props.clientId,
      ),
    );
  }

  getLastName() {
    if (this.state.previousFilter?.type === 'market') {
      return this.state.previousFilter.market?.name;
    } else if (this.state.previousFilter.tag) {
      return this.state.previousFilter.tag?.name;
    }
    return '';
  }

  render() {
    const {
      classes,
      allowTagSelection 
    } = this.props;

    const {
      tab,
      open,
      selectedFilter,
    } = this.state;

    let isSaveable = false;
    if (selectedFilter?.type === 'market') {
      isSaveable = !!selectedFilter.market;
    } else if (selectedFilter) {
      isSaveable = !!selectedFilter.tag;
    }
    if (!allowTagSelection && tab === 'tags') {
      isSaveable = false;
    }

    return (<>
       <FormControl
        variant='outlined'
        
        className={classes.filterDropDown}
        key='filter-serviceline'
      >
        <InputLabel>Market / Label</InputLabel>
         <Select
          value='filter'
          label='Market / Label'
          open={false}
          onOpen={() => this.setState({ open: true })}
          onClick={() => this.setState({ open: true })}
        >
          <MenuItem value='filter'>
            {this.getLastName()}
          </MenuItem>
        </Select>
      </FormControl> 
      {open && (
        <Dialog
          onClose={this.onCancel}
          aria-labelledby='simple-dialog-title'
          open={open}
          fullWidth
          maxWidth='md'
          height={600}
          scroll='paper'
        >
          <DialogTitle className={classes.dialogTitle}>
            Filter by Geographic Market or Label
            <Tabs
              variant='scrollable'
              className={classes.tabs}
              TabIndicatorProps={{ className: classes.indicator }}
              value={tab}
              onChange={this.onTabChange}
            >
              <Tab
                className={classes.tabPanel}
                label='Market'
                value='markets'
                disableRipple
              />
              <Tab
                className={classes.tabPanel}
                label='Label'
                value='tags'
                disableRipple
              />
            </Tabs>
          </DialogTitle>
          <DialogContent dividers className={classes.dialogContent}>
            {tab === 'markets' && this.renderMarketSelect() }
            {!!allowTagSelection && tab === 'tags' && this.renderTagSelect()}
            {!allowTagSelection && tab === 'tags' && this.renderTagSelectOrganization(classes)}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onCancel} color='primary'>
              Cancel
            </Button>
            <Button disabled={!isSaveable} onClick={this.onSave} variant='contained' color='primary'>
              Filter
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>);
  }

  onCancel = () => {
    this.setState({ open: false, selectedFilter: this.state.previousFilter });
  }

  onSave = () => {
    const newState = {};
    if (this.state.tab === 'markets') {
      this.props.dispatch(setMarket(this.state.selectedFilter.market.id));
      newState.type = 'market';
      newState.market = this.state.selectedFilter.market;
      newState.tag = this.state.previousFilter.tag;

    } else {
      newState.type = 'tag';
      newState.tag = this.state.selectedFilter.tag;
      newState.market = this.state.previousFilter.market;
    }

    this.props.onChange?.(newState);
    this.setState({ open: false, previousFilter: newState });
  }

  onTabChange = (_event, tab) => {
    this.setState({ tab })
  }

  renderMarketSelect = () => {
    return (<MarketsSelect market={this.state.selectedFilter?.market} onChange={this.onMarketChanged} />);
  }

  renderTagSelect = () => {
    return (<TagSelector type={this.props.type} tagId={this.state.selectedFilter?.tag?.id} onChange={this.onSelectedTagChanged} />);
  }

  renderTagSelectOrganization = () => {
    return (<TagSelector type={this.props.type} tagId={this.state.selectedFilter?.tag?.id} onChange={this.onSelectedTagChanged} />);
  }

  onSelectedTagChanged = (tag) => {
    this.setState({ 
      selectedFilter: { type: 'tag', tag, },
    });
  }

  getMarket(id = null) {
    const markets = StoreUtil.getData(this.props.markets);
    if (markets && markets.length > 0) {
      return markets.find((market) => market.id === id);
    }
    return null;
  }

  onMarketChanged = (market) => {
    this.setState({ 
      selectedFilter: { type: 'market', market }
    });
  }

  openMarketsEditDialog = () => {
    this.setState({ marketsEditOpen: true });
  };

  closeMarketsEditDialog = () => {
    this.setState({ marketsEditOpen: false });
  };
}

MarketOrTagSelect.propTypes = {
  classes: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  clientId: PropTypes.number,
  marketsClientId: PropTypes.number,
  markets: PropTypes.object,
  market: PropTypes.object,
  tagNamespaces: PropTypes.object,
  filter: PropTypes.object,
  allowTagSelection: PropTypes.bool,
  type: PropTypes.oneOf(['all', 'providers', 'activity_notes', 'organizations']),
};

function mapStateToProps(state) {
  return {
    clientId: state.app.selectedClient,
    marketsClientId: state.markets.clientId,
    markets: MarketsUtil.getMarkets(state),
    market: MarketsUtil.getSelectedMarket(state),
    tagNamespaces: StoreUtil.get(state.tagNamespaces, 'API_TAG_NAMESPACES_LIST_BY_CLIENT'),
  };
}

const styled = withStyles(styles)(MarketOrTagSelect);
const connected = connect(mapStateToProps)(styled);
export { connected as MarketOrTagSelect };
